/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_Dfsm_IosInputs */

const en_colleague_action_dfsm_ios = /** @type {(inputs: Colleague_Action_Dfsm_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download DFSM for iOS`)
};

const ja_colleague_action_dfsm_ios = /** @type {(inputs: Colleague_Action_Dfsm_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM (iOS) をダウンロード`)
};

const fr_colleague_action_dfsm_ios = /** @type {(inputs: Colleague_Action_Dfsm_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger DFSM pour iOS`)
};

const de_colleague_action_dfsm_ios = /** @type {(inputs: Colleague_Action_Dfsm_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM für iOS herunterladen`)
};

/**
* | output |
* | --- |
* | "Download DFSM for iOS" |
*
* @param {Colleague_Action_Dfsm_IosInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_dfsm_ios = /** @type {((inputs?: Colleague_Action_Dfsm_IosInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_Dfsm_IosInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_dfsm_ios(inputs)
	if (locale === "ja") return ja_colleague_action_dfsm_ios(inputs)
	if (locale === "fr") return fr_colleague_action_dfsm_ios(inputs)
	return de_colleague_action_dfsm_ios(inputs)
});